import { z } from "zod";

export enum EAppointmentState {
  PLANNED = "planned",
  CANCELED = "canceled",
  FINALIZED = "finalized",
}

export const appointmentStateDtoSchema = z.nativeEnum(EAppointmentState);

export type TAppointmentStateDto = z.infer<typeof appointmentStateDtoSchema>;
